import React, { useCallback, useMemo, useState } from "react";
import { RadioInput } from "components/Inputs/FormikInputs/RadioInput";
import { InputCardTitle } from "components/InputCards/InputCardTitle";
import { TooltipIcon } from "./TooltipIcon";

const RadioButton = ({
  option,
  subOption,
  name,
  id,
  checked,
  disabled,
  testId,
  onChange,
}) => (
  <RadioInput
    key={id}
    label={
      <>
        {" "}
        <div>{option.label}</div>
        {subOption && <div className="text-secondary">{subOption}</div>}
      </>
    }
    name={name}
    type="radio"
    value={option.value}
    checked={checked}
    disabled={disabled}
    data-testid={testId}
    onChange={onChange}
  />
);

export const RadioButtonCard = ({
  label,
  options,
  subOptions,
  value,
  disabled,
  onChange,
  partKey,
  optionKey,
  description,
  isModalView,
}) => {
  const [isLoading, setIsLoading] = useState(false);
  // state 2: The part/option is not relevant to the order code (i.e., its presentation does not contribute to the order code)
  // https://dev.azure.com/DEVLY-IT-Software-Development/TROX-EB-Website_v2/_wiki/wikis/TROX-System-Configurator.wiki/1132/Product-states
  const notRelevantToOrderCodeOptions = useMemo(
    () => options.filter((opt) => opt.state < 2 || opt.state === 4),
    [options],
  );

  const onRadioBtnChange = useCallback(
    ({ target }) => {
      const changeData = { data: target.value, partKey, optionKey };
      setIsLoading(true);
      onChange({
        changeData,
      });
    },
    [onChange, optionKey, partKey],
  );
  const name = useMemo(
    () =>
      isModalView
        ? label.replaceAll(" ", "-").concat("___modal")
        : label.replaceAll(" ", "-"),
    [label, isModalView],
  );
  const id = useMemo(
    () => `${name}-option.value.replaceAll(
              " ",
              "-"
            )`,
    [name],
  );

  return (
    <>
      <TooltipIcon description={description} />
      <InputCardTitle
        title={label}
        isLoading={isLoading}
        setIsLoading={setIsLoading}
      />
      <div className="d-flex flex-wrap gap-3">
        {notRelevantToOrderCodeOptions.map((option, index) => (
          <RadioButton
            key={index}
            option={option}
            subOption={subOptions && subOptions[index]}
            name={name}
            id={id}
            checked={option.value === value}
            disabled={disabled || option.state !== 0}
            onChange={onRadioBtnChange}
            testId={`${partKey}-${optionKey}-${option.value}`}
          />
        ))}
      </div>
    </>
  );
};
